<template>
  <div>
    <AppHeader />

    <div class="invoice-update-container">
      
      <div class="divider"></div>
      
      <h3>Invoices List</h3>
      
      <div class="invoices-table">
        <div class="table-header">
  <div class="header-cell">Order Id</div>
  <div class="header-cell">Total Amount</div>
  <div class="header-cell">Paid Amount</div>
  <div class="header-cell">Is Paid</div>
  <div class="header-cell">Issued At</div>
</div>
        
        <div class="table-row" v-for="invoice in invoices" :key="invoice.id">
  <div class="table-cell">{{ invoice.orderId }}</div>
  <div class="table-cell">{{ formatCurrency(invoice.totalAmount) }}</div>
  <div class="table-cell">{{ formatCurrency(invoice.paidAmount) }}</div>
  <div class="table-cell">{{ invoice.isPaid ? 'Yes' : 'No' }}</div>
  <div class="table-cell">{{ formatDate(invoice.issuedAt) }}</div>
</div>
      </div>
      <button class="back-btn" @click="goBack">
        <i class="fas fa-arrow-left"></i> Back
      </button>
    </div>
  </div>
  </template>
  
<script>
import axios from 'axios';
export default {
  name: 'InvoiceUpdate',
  data() {
    return {
      loading: false,
      error: null,
      customerId: null,
      customer: {
        phone: '',
        fullName: '',
        totalUnpaid: 0
      },
      payment: {
        amount: '',
        types: 'Cash CCredit',
        discount: 0
      },
      invoices: []
    }
  },
  mounted(){
this.customerId = this.$route.params.customerId;
  },
  created() {
  this.token = localStorage.getItem('authToken'); 
    this.userId = localStorage.getItem('userId'); 
    console.log(this.userId);
    this.fetchUserInvoices();
  },
  methods: {
   async fetchUserInvoices() {
  this.loading = true;
    this.$root.isLoading = true;

  this.error = null;
  
  try {
    const response = await axios.get(`${this.$BASE_API_URL}/api/orders/user-invoices/${this.customerId}`, {
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
    });
    
    if (response.data.status) {
      this.invoices = response.data.data;
      this.calculateCustomerTotals();
    } else {
      throw new Error(response.data.message || 'Failed to fetch invoices');
    }
  } catch (err) {
    this.error = err.response?.data?.message || err.message;
    console.error('Error fetching invoices:', err);
  } finally {
    this.loading = false;
      this.$root.isLoading = false;

  }
},
goBack() {
      this.$router.go(-1);
    },
    calculateCustomerTotals() {
  this.customer.totalUnpaid = this.invoices.reduce((sum, invoice) => {
    return sum + parseFloat(invoice.remainingAmount || 0);
  }, 0);
},
    validateAmount() {
      if (this.payment.amount < 0) {
        this.payment.amount = 0;
      }
      this.payment.amount = parseFloat(this.payment.amount).toFixed(2);
    },
    formatCurrency(value) {
      return parseFloat(value || 0).toFixed(2);
    },
    formatDate(dateString) {
  if (!dateString) return 'N/A';
  const options = { 
    year: 'numeric', 
    month: 'short', 
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  };
  return new Date(dateString).toLocaleString(undefined, options);
},
    cancelUpdate() {
      // Handle cancel logic
    },
    submitUpdate() {
      // Handle submit logic
    }
  }
}
</script>
  <style scoped>
  .invoice-update-container {
    font-family: Arial, sans-serif;
    padding: 20px;
    margin: 0 auto;
  }
  .info-value-input {
  flex-grow: 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  width: 100%;
  max-width: 200px; 
}
  
  h1 {
    font-size: 24px;
    margin-bottom: 20px;
  }
  
  h3 {
    font-size: 18px;
    margin: 20px 0 10px;
  }
  
  .info-row {
    display: flex;
    margin-bottom: 10px;
  }
  
  .info-row label {
    font-weight: bold;
    width: 150px;
  }
  
  .info-value {
    flex-grow: 1;
  }
  
  .divider {
    border-top: 1px solid #ccc;
    margin: 20px 0;
  }
  
  .invoices-table {
    width: 100%;
    color: var(--font-color);
    border-collapse: collapse;
    margin-bottom: 20px;
  }
  
  .table-header, .table-row {
    display: flex;
    padding: 8px 0;
  }
  
  .table-header {
    font-weight: bold;
    border-bottom: 2px solid #ccc;
  }
  
  .table-row {
    border-bottom: 1px solid #eee;
  }
  .action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 25px;
}
  .header-cell, .table-cell {
    flex: 1;
    padding: 0 5px;
  }
  
  .search-bar {
    margin-top: 20px;
  }
  
  .search-bar input {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  .loading, .error {
  padding: 20px;
  text-align: center;
  color: #666;
}

.error {
  color: #d9534f;
}

.header-cell, .table-cell {
  flex: 1;
  min-width: 0;
  padding: 0 5px;
}
  </style>